import { useState, useEffect, useCallback } from 'react';
import { FacilityGroupsApi } from '@/api/clients/facility-groups/facility-groups.api';

export const useGetFacilityGroups = (organizationId, options = {}) => {
  const { enabled = true, limit = 100 } = options;

  const [facilityGroups, setFacilityGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchFacilityGroups = useCallback(async () => {
    if (!organizationId) {
      setLoading(false);
      return [];
    }

    setLoading(true);
    setError(null);
    try {
      const response = await FacilityGroupsApi.getFacilityGroups(
        organizationId,
        { limit },
      );
      const data = response.data.data || [];
      setFacilityGroups(data);
      return data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to fetch facility groups';
      setError(errorMessage);
      console.error('Error fetching facility groups:', err);
      return [];
    } finally {
      setLoading(false);
    }
  }, [organizationId, limit]);

  useEffect(() => {
    if (enabled) {
      fetchFacilityGroups();
    }
  }, [fetchFacilityGroups, enabled]);

  return {
    facilityGroups,
    loading,
    error,
    refetch: fetchFacilityGroups,
  };
};
